import createStore from "astrid-helpers/src/createStore";
export const [getHighlights, setHighlights, useHighlights, onHighlights] = createStore([]);
//# sourceMappingURL=highlights.js.map